module.exports = __webpack_public_path__ + "img/69.fcf3a04a.png";